const INIT_TOKEN = 'AUTH/INIT_TOKEN';

export default function initTokenAction(tokens: any) {
  return {
    type: INIT_TOKEN,
    payload: tokens
  };
}

export { INIT_TOKEN };